export default "__VITE_ASSET__CJUquhuJ__"